// extracted by mini-css-extract-plugin
export default {"title":"RrMQ_CKh6pgNb0QLH7Lb","warningContainer":"_gJHjkdMXeI_xqAmll3S","buttonsContainer":"twCCw5wkwy0T8IAz_wwL","cancelBtn":"ISgKlpNQmxQFPfRqAoQ3"};